
import { IMenuListItem } from "@/lib/interfaces/menu-list-item.interface";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { FeatureModule } from "@/store/modules/feature.store";
import { UserModule } from "@/store/modules/me-user.store";
import { PartnerModule } from "@/store/modules/partner";
import { Component, Vue } from "vue-property-decorator";
import TheNavigationLayout from "./TheNavigationLayout.vue";

@Component({ components: { TheNavigationLayout } })
export default class TheReportList extends Vue {
  ActionEnum = ActionEnum;
  ResourceEnum = ResourceEnum;

  route(route: string) {
    this.$router.push({ name: route });
  }

  get items(): IMenuListItem[] {
    if (!this.isAuthenticated) {
      return [];
    }

    if (!UserModule.abilities.can(ActionEnum.READ, ResourceEnum.LOGGED_IN_USER)) {
      return [];
    }

    return [
      {
        icon: "mdi-car-wrench",
        text: "navigation.ThePartnerList.report",
        link: "/my/damages",
        isEnabled: true
      },
      {
        icon: "mdi-calendar-multiselect",
        text: "navigation.TheOnlineBookingList.title",
        link: "/my/bookings",
        isEnabled: this.isOnlineBooking
      },
      {
        icon: "mdi-file-document-outline",
        text: "navigation.TheDigitalSignatureList.title",
        link: "/my/signatures",
        isEnabled: this.isSignature
      }
    ];
  }

  get isAuthenticated() {
    return UserModule.isAuthenticated;
  }

  get fleetIds() {
    return UserModule.distinctFleetIds;
  }

  /**
   */
  get isCustomerSignup(): boolean {
    return PartnerModule.partner.settings?.bookedServices.customer ?? false;
  }

  /**
   */
  get isOnlineBookingActive(): boolean {
    return FeatureModule.onlineBooking;
  }

  /**
   * Is Online Booking license enabled
   */
  get isOnlineBooking(): boolean {
    return (this.isOnlineBookingActive && PartnerModule.partner.settings?.bookedServices?.onlineBooking) ?? false;
  }

  /**
   * Is Signature license enabled
   */
  get isSignature(): boolean {
    return PartnerModule.partner.settings?.bookedServices?.sign ?? false;
  }
}
